import InitApi from "api/InitApi";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import useTokenStore from "store/tokenStore";

const useDownloadPublisherCatalogueExport = () => {
	const { accessToken } = useTokenStore();

	return useMutation(async (filter = "missing_any") => {
		const instance = await InitApi({ accessToken });
		const response = await instance.get("/publisher/books/media-export", {
			params: { filter },
			responseType: "blob",
		});

		const blob = new Blob([response.data], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		});
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.href = url;
		link.setAttribute(
			"download",
			`akello_book_list_${filter}.xlsx`
		);
		document.body.appendChild(link);
		link.click();
		link.remove();
		window.URL.revokeObjectURL(url);
		toast.success("Book list downloaded");
		return true;
	});
};

export default useDownloadPublisherCatalogueExport;
